import { render, staticRenderFns } from "./StaffSelectModal.vue?vue&type=template&id=3c0854bd&scoped=true&"
import script from "./StaffSelectModal.vue?vue&type=script&lang=ts&"
export * from "./StaffSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./StaffSelectModal.vue?vue&type=style&index=0&id=3c0854bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0854bd",
  null
  
)

export default component.exports